import { render, staticRenderFns } from "./AdminCalendar.vue?vue&type=template&id=04261073&scoped=true&"
import script from "./AdminCalendar.vue?vue&type=script&lang=js&"
export * from "./AdminCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AdminCalendar.vue?vue&type=style&index=0&id=04261073&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04261073",
  null
  
)

export default component.exports